export default "__VITE_ASSET__Be7hmQDc__"